module.exports = {
      id: "british-flag-usage",
      viewBox: "0 0 16 12",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#british-flag",
      toString: function () {
        return this.url;
      }
    }